import { useState, useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import useAxios from "../../../hooks/useAxios";
import axiosInstance from "../../../apis/commonAPI";
import { PAGE_LIMITS, modulePermissions } from "../../../constants";
import Loader from "../../../components/loader";
import Table from "../../../components/tables/table";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { domainFieldsData,DomainSubDomain } from "../../../data/TableData";
// import useUser from "../../hooks/useUser";


const MODULE_URI = "/master/domainlisting";
const FETCH_API_URL = `customer/get-customer-listing-data`;
const CHANGE_STATUS_API_URL = `customer/change-customer-status?dataId=`;
const totalCount = 3;
export default function DomainListing() {
  
//   const [searchParams, setSearchParams] = useSearchParams();
//   const addEditCustomerToast = searchParams.get("addEditCustomerToast");

  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(PAGE_LIMITS[0]);
  const [tableData, setTableData] = useState([]);
  const [addUpdate, setAddUpdate] = useState(false);

  
//   const { modulePermissions } = useUser(MODULE_URI);
  const [resData, error, loading, axiosFetch] = useAxios();
  const [resStatusData, errorStatus, loadingStatus, axiosFetchStatus] = useAxios();

const FETCH_API_URL = "master/getDomainsData";
//   const [getStatus, errorStatus, loadingStatus, axiosFetchStatus] = useAxios();

  

//   useEffect(() => {
//     if (addEditCustomerToast === "edit") {
//       toast.success("Customer updated successfully", {
//         position: toast.POSITION.TOP_RIGHT,
//       });
//     } else if (addEditCustomerToast === "add") {
//       toast.success("Customer Added successfully", {
//         position: toast.POSITION.TOP_RIGHT,
//       });
//     }
//   }, [addEditCustomerToast]);

  const getData = (url) => {
    axiosFetch({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };

  const handleSearchFieldChange = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
  };

  useEffect(() => {
    getData(FETCH_API_URL)

  },[FETCH_API_URL, loadingStatus])
  console.log("domain res ", resData)

  


  useEffect(() => {
    if (resData !== undefined && resData.length > 0) {
      const tempData = resData?.[0]?.DomainsDataAll.map((item) => {
       
        let subDomainArray = []
        item.subDomains?.map((fetchRows) =>{
          if(fetchRows?.subDomainName !==null && fetchRows?.subDomainName !=="")
         subDomainArray.push(`${fetchRows?.subDomainName}, `);

        })
        return {
          _id: item._id,
          domainName: item.domainName,
          subDomainName: subDomainArray,
       
          status: item.status,
        
        };
      });

      setTableData(tempData);
    } else {
      setTableData([]);
    }
  }, [resData]);

  function navigateToEditPage(rowIndex) {
    if (rowIndex >= 0) {
      const currItem = tableData[rowIndex];

      navigate(`${MODULE_URI}/add/${currItem?._id}`);
    } else {
      // navigate(MODULE_URI);
    }
  }
   const handleStatus = async (rId, status,id) => {
    
      await axiosFetchStatus({
        axiosInstance: axiosInstance,
        url: `master/updateDomainStatusData/${rId}`,
        method: "POST",
        requestConfig: {
          data: {
            status,
          },
        },
      });
      setAddUpdate(true);
  
     
    };
    useEffect(() => {
      if (errorStatus) {
  
        toast.error(
          `Your status could not be Updated!!error:${errorStatus}`,
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      } else if (addUpdate) {
        toast.info(
          `Your status is Updated!!`,
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
      }
    },[loadingStatus])
  

  return (
    <>
    <div className="card min-height-100">
      <div className="pump-report-top">
        <h2 className="text-navyBlue">Domain List</h2>
        <ToastContainer />

        <div className="btn-wrapper">
          {modulePermissions?.canAdd && (
            <Link
              to={`${MODULE_URI}/add`}
              className="btn btn-sm btn-blue rounded-10"
            >
              Add Domain
            </Link>
          )}

          {/* {modulePermissions.canDownload && (
            <button className="btn btn-sm btn-green rounded-10">
              Download Data
            </button>
          )} */}
        </div>
      </div>

      {/* {loading && <Loader />} */}

      {/* {!loading && error && (
        <div className="label label-block label-red-bg rounded-10 mt-10 mb-10">
          {error || "Something went wrong!!"}
        </div>
      )} */}

      <div className="pump-search">
        <span className="text-gray">
          {" "}
          Show Entries
          <select
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            onChange={handleLimitChange}
          >
            {PAGE_LIMITS.map((value, index) => (
              <option key={index} value={value}>
                {value}
              </option>
            ))}
          </select>
        </span>

        <span>
          {" "}
          <input
            type="text"
            className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
            placeholder="Search"
            onKeyDown={handleSearchFieldChange}
          />
        </span>
      </div>
      <div className="company-table ">
        <Table
          tableColumns={domainFieldsData}
          tableData={tableData}
          tableSettings={{
            page,
            pageSize: limit,
            totalCount,
          }}
          action={true}
          // modulePermissions={modulePermissions}
      
          handlePage={setPage}
          handleEdit={navigateToEditPage}
          handleStatus = {handleStatus}

        />
      </div>
    </div>
    </>
    
  );
}
